<script setup lang="ts">
import { computed, inject, type Ref } from 'vue';
import { useField } from 'vee-validate';
import { useI18n } from 'vue-i18n';
import type { Locales } from '@/services/types/api.types';

const { t } = useI18n();

// PROPS
const props = defineProps<{
  name: string;
}>();

// COMPUTED
const nameFr = computed(() => `${props.name}.fr`);
const nameEn = computed(() => `${props.name}.en`);

const { value: valueFr, errorMessage: errorMessageFr } = useField<string | null>(nameFr.value);
const { value: valueEn, errorMessage: errorMessageEn } = useField<string | null>(nameEn.value);
const editLocale = inject<Ref<Locales>>('editLocale');

// FUNCTIONS
const removeFile = async (lang: string, index: number) => {
  const content = lang === 'fr' ? valueFr : valueEn;
  content.value.splice(index, 1);
};
</script>

<template>
  <div v-show="(valueEn != null && valueEn.length > 0) || (valueFr != null && valueFr.length > 0)">
    <div v-if="editLocale === 'fr'">
      <div class="row q-gutter-sm">
        <div v-for="(item, index) in valueFr" :key="index" class="col-6">
          <q-card>
            <q-card-section horizontal>
              <q-card-section>
                <q-icon name="attach_file" />
              </q-card-section>
              <q-separator vertical />
              <q-card-section>
                {{ item.name }}
              </q-card-section>
            </q-card-section>
            <q-card-actions>
              <q-btn @click="removeFile(editLocale, index)" :label="t('context.removeFile')" />
            </q-card-actions>
          </q-card>
        </div>
      </div>
      <div>
        <!--            TODO: HIDDEN-->
        <q-input :model-value="JSON.stringify(valueFr)" type="hidden" />
      </div>
    </div>
    <div v-else-if="editLocale === 'en'">
      <div class="row q-gutter-sm">
        <div v-for="(item, index) in valueEn" :key="index" class="col-6">
          <q-card>
            <q-card-section horizontal>
              <q-card-section>
                <q-icon name="attach_file" />
              </q-card-section>
              <q-separator vertical />
              <q-card-section>
                {{ item.name }}
              </q-card-section>
            </q-card-section>
            <q-card-actions>
              <q-btn @click="removeFile(editLocale, index)" :label="t('context.removeFile')" />
            </q-card-actions>
          </q-card>
        </div>
      </div>

      <div>
        <!--            TODO: HIDDEN-->
        <q-input :model-value="JSON.stringify(valueEn)" type="hidden" />
      </div>
    </div>
    <q-banner class="text-white bg-red q-mb-sm" v-if="!editLocale">Missing editLocale injection</q-banner>
  </div>
</template>
